/**
 * Implementation of Routes file
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import { ReactNode } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardLayout from "./pages/Dashboard";
import Dashboard from "./pages/Dashboard/Dashboard";
import Homepage from "./pages/Homepage";
import Login from "./pages/Auth/Login";
import Settings from "./pages/Settings";
import ButtonSettings from "./pages/Settings/ButtonSettings";
import GeneralSettings from "./pages/Settings/GeneralSettings";
import Widgets from "./pages/Widgets";
import EmailSent from "./pages/Auth/EmailSent";
import Auth from "./pages/Auth";
import Verify from "./pages/Auth/Verify";
import ProtectedLayout from "./components/ProtectedLayout";
import Onboarding from "./pages/Onboarding";
import MonitorInfo from "./pages/Onboarding/MonitorInfo";
import MonitorRegion from "./pages/Onboarding/MonitorRegion/monitorRegion";
import MonitorAlert from "./pages/Onboarding/MonitorAlert";
import Monitors from "./pages/Dashboard/Monitors";
import MonitorDetail from "./pages/Dashboard/Monitors/monitor";
import Billing from "./pages/Dashboard/Billing";
import {Secured} from "./components/Secured";
import PreLogin from "./pages/Auth/PreLogin";
import ProcessRedirect from "./pages/Auth/ProcessRedirect";
import MonitorMain from "./pages/Onboarding/MonitorMain";

const ProtectedDashboardLayout = ProtectedLayout(DashboardLayout)
const ProtectedOnboarding = ProtectedLayout(Onboarding)

export default function MainRouter() {

  

  return (
    <BrowserRouter>
      <div className="fixed top-0 left-0 right-0 bg-gray-300 shadow-xl text-center py-2 text-lg md:hidden lg:hidden xl:hidden">For a better experience, please view this on a tablet or desktop</div>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/process-redirect" element={<Secured><ProcessRedirect/></Secured>}/>
        <Route path="auth" element={<Auth />}>
          <Route path="login" element={<Login />} />
          <Route path="email-sent" element={<EmailSent />} />
          <Route path="verify" element={<Verify />} />
          <Route path="pre-login" element={<PreLogin/>}/>
        </Route>
          <Route path="onboarding" element={<Secured><Onboarding /></Secured>}>
          <Route path="monitor-main" element={<Secured><MonitorMain /></Secured>} /> 
          <Route path="monitor-info" element={<MonitorInfo />} />
          <Route path="monitor-region" element={<MonitorRegion />} />
          <Route path="monitor-alert" element={<MonitorAlert />} />
        </Route>
        <Route path="dashboard" element={<Secured><DashboardLayout/></Secured>}>
          <Route path="home" element={<Dashboard />} />
          <Route path="monitors">
            <Route path=":monitorId" element={ <MonitorDetail />} />
            <Route index element={<Monitors />} />
          </Route>
          <Route path="billing" element={<Billing />} />
          <Route path="settings" element={<Settings />}>
            <Route path="general" element={<GeneralSettings />} />
            <Route path="button" element={<ButtonSettings />} />  
        </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}